module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("PART I")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title-2"
  }, [_c('span', [_vm._v("THE TABLETS")])]), _vm._v(" "), _c('p', {
    staticClass: "image-center"
  }, [_c('span', [_c('img', {
    staticClass: "svg",
    attrs: {
      "alt": "image",
      "src": "images/fig02-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('i', [_vm._v("The Memorial Hall of Harvard consists of three main divisions: one of them a theatre, for academic ceremonies; another a vast refectory covered with a timbered roof, hung about with portraits and lighted by stained windows … and the third, the most interesting, a chamber high, dim, and severe, consecrated to the sons of the university who fell in the long Civil War")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ENRY")]), _vm._v(" J"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AMES")]), _vm._v(", "), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSTONIANS")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f0e958e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part1chapter01.vue
// module id = 84
// module chunks = 0